<template>
  <a-drawer
    :width="600"
    :title="dialogTitle"
    placement="right"
    :open="isVisibles"
    @close="handleClose"
  >
    <template #extra>
      <a-button style="margin-right: 8px" :icon="h(CloseOutlined)" @click="handleClose"
        >取消</a-button
      >
      <a-button type="primary" @click="submitForm" :icon="h(CheckOutlined)"
        >保存节点</a-button
      >
    </template>
    <a-form ref="formRef" :rules="dynamicRules" :label-col="{ span: 4 }">
      <a-divider>设置节点信息</a-divider>
      <a-form-item label="节点id" v-bind="validateInfos.nodeId" name="nodeId">
        <a-input
          v-model:value="flowNodeData.nodeId"
          placeholder="请输入节点id"
          maxlength="20"
          disabled="true"
          show-count
        />
      </a-form-item>
      <a-form-item label="节点名称" v-bind="validateInfos.label" name="label">
        <a-input
          v-model:value="flowNodeData.nodeName"
          placeholder="请输入节点名称"
          maxlength="10"
          show-count
          allowClear
        />
      </a-form-item>
      <a-divider>设置审核信息</a-divider>
      <a-form-item label="审核方式" v-bind="validateInfos.auditType" name="auditType">
        <a-radio-group
          v-model:value="flowNodeData.auditType"
          name="radioGroup"
          @change="auditTypeChange"
        >
          <a-radio :value="AuditTypeEnum.appointUser">指定人员</a-radio>
          <a-radio :value="AuditTypeEnum.appointRole">指定角色</a-radio>
          <a-radio :value="AuditTypeEnum.appointDepartment">指定部门</a-radio>
          <a-radio :value="AuditTypeEnum.appointPost">指定岗位</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item
        label="审核人员"
        v-bind="validateInfos.auditKey"
        name="auditKey"
        v-if="flowNodeData.auditType === AuditTypeEnum.appointUser"
      >
        <a-select
          allowClear
          v-model:value="flowNodeData.auditKey"
          :options="
            userData.map((s) => {
              return { value: s.userId, label: s.userName };
            })
          "
        ></a-select>
      </a-form-item>
      <a-form-item
        label="审核角色"
        v-bind="validateInfos.auditKey"
        name="auditKey"
        v-if="flowNodeData.auditType === AuditTypeEnum.appointRole"
      >
        <a-select
          allowClear
          v-model:value="flowNodeData.auditKey"
          :options="
            roleData.map((s) => {
              return { value: s.roleId, label: s.roleName };
            })
          "
        ></a-select>
      </a-form-item>
      <a-form-item
        label="审核部门"
        v-bind="validateInfos.auditKey"
        name="auditKey"
        v-if="flowNodeData.auditType === AuditTypeEnum.appointDepartment"
      >
        <a-select
          allowClear
          v-model:value="flowNodeData.auditKey"
          :options="
            departmentData.map((s) => {
              return { value: s.departmentId, label: s.departmentName };
            })
          "
        ></a-select>
      </a-form-item>
      <a-form-item
        label="审核岗位"
        v-bind="validateInfos.auditKey"
        name="auditKey"
        v-if="flowNodeData.auditType === AuditTypeEnum.appointPost"
      >
        <a-select
          allowClear
          v-model:value="flowNodeData.auditKey"
          :options="
            postData.map((s) => {
              return { value: s.postId, label: s.postName };
            })
          "
        ></a-select>
      </a-form-item>
      <a-form-item label="抄送给">
        <a-select
          allowClear
          mode="multiple"
          style="width: 80%"
          v-model:value="flowNodeData.carbonCopyUser"
          :options="
            userData.map((s) => {
              return { value: s.userId, label: s.userName };
            })
          "
        ></a-select>
        <a-tooltip placement="bottom" color="#f50">
          <template #title>
            <span>当前节点审核通过后，流程会自动发送给抄送人</span>
          </template>
          <QuestionCircleOutlined
            style="font-size: 20px; margin-left: 5px; color: #f50"
          />
        </a-tooltip>
      </a-form-item>
      <a-divider>设置审核期限</a-divider>
      <a-form-item label="审核期限">
        <a-radio-group v-model:value="flowNodeData.isSetExamineExpire" name="radioGroup1">
          <a-radio :value="true">设置审核期限</a-radio>
          <a-radio :value="false">任意时间审核</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="超时日期" v-if="flowNodeData.isSetExamineExpire">
        <div style="align-items: center; display: flex">
          从
          <a-input-number
            v-model:value="flowNodeData.expireDate"
            :min="1"
            :max="100"
            style="width: 120px"
          />
          <a-select v-model:value="flowNodeData.expireType" style="width: 120px">
            <a-select-option :value="1">天</a-select-option>
            <a-select-option :value="2">小时</a-select-option>
          </a-select>
          后，未审批自动执行超时动作
        </div>
      </a-form-item>
      <a-form-item label="超时动作" v-if="flowNodeData.isSetExamineExpire">
        <a-radio-group v-model:value="flowNodeData.expireAction" name="radioGroup2">
          <a-radio :value="ExpireActionEnum.NoAction">等待审批</a-radio>
          <a-radio :value="ExpireActionEnum.Approve">自动批准</a-radio>
          <a-radio :value="ExpireActionEnum.AuditRefuse">自动拒绝</a-radio>
          <a-radio :value="ExpireActionEnum.RejectNode">驳回到上个节点</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="过期提醒" v-if="flowNodeData.isSetExamineExpire">
        <a-radio-group v-model:value="flowNodeData.isExpireRemind" name="radioGroup3">
          <a-radio :value="true">提醒</a-radio>
          <a-radio :value="false">不提醒</a-radio>
        </a-radio-group>
      </a-form-item>

      <a-form-item
        label="提前"
        v-if="flowNodeData.isExpireRemind && flowNodeData.isSetExamineExpire"
      >
        <div style="align-items: center; display: flex">
          <a-input-number
            v-model:value="flowNodeData.soonExpireDate"
            :min="10"
            :max="60"
            style="width: 50%"
          />
          <span>分钟提醒审核人</span>
        </div>
      </a-form-item>
      <a-form-item
        label="提示信息"
        v-bind="validateInfos.remindContent"
        name="remindContent"
        v-if="flowNodeData.isExpireRemind && flowNodeData.isSetExamineExpire"
      >
        <a-input
          v-model:value="flowNodeData.remindContent"
          placeholder="请输入提示信息，即将超时会把该内容发送给审核人"
          maxlength="20"
          show-count
          allowClear
        />
      </a-form-item>
    </a-form>
  </a-drawer>
</template>
<script lang="ts" setup>
import { PropType, ref, watch, h, computed } from "vue";
import { cloneDeep } from "lodash";
import { ordinaryNodeModel } from "../../typescript/nodeModel";
import {
  AuditTypeEnum,
  ExpireActionEnum,
  ExpireTypeEnum,
  FlowNodeStateEnum,
  NodeTypeEnum,
} from "../../typescript/nodeEnum";
import { Form, message } from "ant-design-vue";
import { userData, roleData, departmentData, postData } from "../../typescript/mockData";
import {
  CheckOutlined,
  CloseOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons-vue";
// 组件属性定义
const props = defineProps({
  isVisibles: Boolean,
  dialogTitle: String,
  nodeModel: { type: Object as PropType<any>, required: true },
});

// 声明 emit
const emit = defineEmits(["closeBnt", "saveNodeClick"]);

//流程节点模型
const flowNodeData = ref<ordinaryNodeModel>({
  nodeId: "",
  nodeType: NodeTypeEnum.OrdinaryNode,
  auditType: AuditTypeEnum.appointUser,
  isSetExamineExpire: false,
  expireDate: 1,
  expireAction: ExpireActionEnum.NoAction,
  isExpireRemind: false,
  soonExpireDate: 10,
  remindContent: "",
  expireType: ExpireTypeEnum.day,
  carbonCopyUser: [],
  nodeName: "",
  auditState: FlowNodeStateEnum.UnPublish,
  auditKey: [],
});

watch(
  () => props.isVisibles,
  () => {
    resetFields();
    if (props.isVisibles) {
      const nodeData = props.nodeModel;
      flowNodeData.value.nodeId = nodeData.nodeId;
      flowNodeData.value.nodeName = nodeData.nodeName;
      flowNodeData.value.auditType =
        nodeData.auditType === 0 ? AuditTypeEnum.appointUser : nodeData.auditType;
      flowNodeData.value.auditState =
        nodeData.auditState === 0 ? FlowNodeStateEnum.UnPublish : nodeData.auditState;
      flowNodeData.value.auditKey = nodeData.auditKey ?? [];
      flowNodeData.value.carbonCopyUser = nodeData.carbonCopyUser ?? [];
      flowNodeData.value.isSetExamineExpire = nodeData.isSetExamineExpire ?? false;
      flowNodeData.value.expireDate = nodeData.expireDate ?? 1;
      flowNodeData.value.expireAction =
        nodeData.expireAction ?? ExpireActionEnum.NoAction;
      flowNodeData.value.isExpireRemind = nodeData.isExpireRemind ?? false;
      flowNodeData.value.soonExpireDate = nodeData.soonExpireDate ?? 10;
      flowNodeData.value.remindContent = nodeData.remindContent ?? "";
      flowNodeData.value.nodeType = nodeData.nodeType ?? NodeTypeEnum.OrdinaryNode;
      flowNodeData.value.expireType =
        nodeData.expireType === 0 || nodeData.expireType === undefined
          ? 1
          : nodeData.expireType;
    }
  }
);

// 动态验证规则
const dynamicRules = computed(() => {
  const rules: any = {
    label: [{ required: true, message: "请输入节点名称" }],
    auditType: [{ required: true, message: "请选择审核方式" }],
  };

  // 根据当前审核方式动态设置验证规则
  switch (flowNodeData.value.auditType) {
    case AuditTypeEnum.appointUser:
      rules.auditKey = [{ required: true, message: "请选择审核人员" }];
      break;
    case AuditTypeEnum.appointRole:
      rules.auditKey = [{ required: true, message: "请选择审核角色" }];
      break;
    case AuditTypeEnum.appointDepartment:
      rules.auditKey = [{ required: true, message: "请选择审核部门" }];
      break;
    case AuditTypeEnum.appointPost:
      rules.auditKey = [{ required: true, message: "请选择审核岗位" }];
      break;
  }

  // 审核期限相关验证
  if (flowNodeData.value.isSetExamineExpire) {
    rules.expireDate = [{ required: true, message: "请输入超时日期" }];
    rules.expireAction = [{ required: true, message: "请选择超时动作" }];

    if (flowNodeData.value.isExpireRemind) {
      rules.soonExpireDate = [{ required: true, message: "请输入提前提醒时间" }];
      rules.remindContent = [{ required: true, message: "请输入提示信息" }];
    } else {
      rules.soonExpireDate = [];
      rules.remindContent = [];
    }
  } else {
    // 不设置审核期限时，清空相关验证
    rules.expireDate = [];
    rules.expireAction = [];
    rules.isExpireRemind = [];
    rules.soonExpireDate = [];
    rules.remindContent = [];
  }

  return rules;
});

const { resetFields, validate, validateInfos } = Form.useForm(
  flowNodeData.value,
  dynamicRules
);

//审核方式改变
const auditTypeChange = function () {
  flowNodeData.value.auditKey = [];
};

const submitForm = () => {
  validate()
    .then(() => {
      if (
        flowNodeData.value.carbonCopyUser !== undefined &&
        flowNodeData.value.carbonCopyUser.some((f) =>
          flowNodeData.value.auditKey.includes(f)&&
            flowNodeData.value.auditType === AuditTypeEnum.appointUser
        )
      ) {
        message.warning("审核人和抄送人不能是同一个人");
        return;
      }
      if (
        flowNodeData.value.isExpireRemind &&
        (flowNodeData.value.remindContent == "" ||
          flowNodeData.value.remindContent === undefined)
      ) {
        message.warning("请输入过期提醒内容");
        return;
      }
      emit("saveNodeClick", cloneDeep(flowNodeData.value));
      emit("closeBnt");
    })
    .catch(() => {
      // message.error(ers);
    });
};

//关闭事件
const handleClose = () => {
  emit("closeBnt");
  // resetForm(ruleFormRef.value);
};
</script>
